module.exports = __webpack_public_path__ + "img/align-center.4f81c88e.svg";